<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD"
    [click]="true" (eventClick)="cambioPeriodo($event)"/>
  <app-filters filtros [name]="'proyFinanciera.escenarioProyeccion.escenario' | translate"
    [array]="escenariosShow" [typeFilter]="Filters.ESCENARIOS" [click]="false"
    (eventClick)="escenarioChange($event)">
  </app-filters>
  @if(sucursales.length > 1){
    <app-filters filtros [name]="'filtros.sucursales'+tagInstitucion | translate" [array]="sucursales"
      [typeFilter]="Filters.ESCENARIOS" [click]="false" 
      (eventClick)="sucursalChange($event)">
    </app-filters> 
  }     
  <app-filters filtros [name]="'filtros.ind' | translate" [consolidado]="consolidadoInd"
    [array]="indicadores" [typeFilter]="Filters.SUCURSALES" [click]="false"
    (eventClick)="filtroIndicadores($event)">
  </app-filters>
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="resetFilters()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <!-- Vista tabla grafica prinicpal -->
    @if(!vistaGraf){
      <div class="containerAll w3-scroll">
        <!-- Tabla de indicadores -->
        <div class="zona1 w3-row">
          <div class="w3-row w3-header-cuadrante">
            <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
              <span class="w3-margin-left-contenido">
                @if(!consolidado){{{'segPresupuestal.razonesFinancieras.sucursal'+tagInstitucion | translate}}} {{ sucursalSeleccionada?.name }}</span>
              <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
              <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
            </div>
            <div class="w3-rest w3-right">
              <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
                  [matMenuTriggerFor]="opcionesTabla" matTooltip="Más opciones">
                  more_vert
              </mat-icon>
              <mat-menu #opcionesTabla="matMenu">
                <button class="mat-menu-item" mat-menu-item (click)="verGraficas()">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'segPresupuestal.razonesFinancieras.verGraf' | translate}}</span>
                </button> 
                <button class="mat-menu-item" mat-menu-item (click)="exportarTabla()">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button> 
              </mat-menu>
            </div>
          </div>
          <div class="w3-row zonaTabla w3-scroll">
            @if(dataIndicadores.length == 0){
              <app-skeleton-table [columnas]="4" [filas]="6" />
            }@else {
              <table class="w3-table">
                <thead>
                  <tr class="w3-table-title w3-center">
                    <th class=" marginsH stikyColumCon">{{'segPresupuestal.razonesFinancieras.titTab1' | translate}}</th>
                    <th class="w3-border-right-balance stikyColumCon">
                      <mat-icon class="iconoMen" [ngStyle]="{'color':'grey'}" style="font-weight: bold; margin-left: -30%; cursor: pointer;"
                      (click)="visibleEncSem = !visibleEncSem;" fontSet="material-icons-outlined" 
                      [matTooltip]="(visibleEncSem 
                        ? 'segPresupuestal.razonesFinancieras.ocultarSem' 
                        : 'segPresupuestal.razonesFinancieras.mostrarSem') | translate">
                        {{ visibleEncSem ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </th>
                    @if(visibleEncSem){
                      @for(semtxt of encSemaforos; track $index){
                        <th class="w3-border-right-balance marginsH stikyColumCon borde-semaforo semaforo"
                          [style.--color-semaforo]="getColorSem(semtxt)">{{semtxt}}</th>
                      }
                    }
                    <th class="w3-border-right-balance marginsH stikyColumCon">{{'segPresupuestal.razonesFinancieras.titTab2' | translate}}</th>
                    <th class="w3-border-right-balance marginsH stikyColumCon">{{'segPresupuestal.razonesFinancieras.titTab3' | translate}}</th>
                    <th class="w3-border-right-balance marginsH stikyColumCon">{{'segPresupuestal.razonesFinancieras.titTab4' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (ind of dataIndicadores; track $index) {
                    @if(ind.nivel == 1 && ind.check){
                      <tr class="w3-table-trtd" style="cursor: pointer;" (click)="toggleExpansion(ind)">
                        <td class="borderAllLow marginsH alinLeft" [matTooltip]="ind.formula" [style.padding-left.px]="ind.nivel * 10" [attr.colspan]="visibleEncSem ? 8 : 5">
                          <mat-icon class="material-icons-outlined" style="vertical-align: middle; font-size: 18px; margin-right: 4px;"
                            [matTooltip]="(ind.expandido 
                              ? 'segPresupuestal.estadoFinanciero.expandir' 
                              : 'segPresupuestal.estadoFinanciero.contraer') | translate">
                              {{ ind.expandido ? 'expand_more' : 'chevron_right' }}
                          </mat-icon>
                          <span [style.font-weight]="ind.nivel === 1 ? 'bold' : 'normal'">
                              {{ ind.nombre }}
                          </span>
                        </td>
                        <td></td>
                        @if(visibleEncSem){@for(semtxt of encSemaforos; track $index){<td></td>}}
                      </tr>
                    }@else if(ind.expandido) {
                      <tr class="w3-table-trtd" style="cursor: pointer;" [ngClass]="{'selection': indSeleccionado?.id == ind.id}" (click)="indSelect(ind)" matTooltip="{{'segPresupuestal.razonesFinancieras.ttSelectInd' | translate}}">
                        <td class="borderLowInf borderLowIzq borderLowSup marginsH alinLeft" [matTooltip]="ind.formula" [style.padding-left.px]="ind.nivel * 20">
                          <span [style.font-weight]="ind.nivel === 1 ? 'bold' : 'normal'">
                              {{ ind.nombre }}
                          </span>
                        </td>
                        <td class="borderLowInf borderLowDer borderLowSup"></td>
                        @if(visibleEncSem){
                          @for (semtxt of encSemaforos; track $index) {
                            <th class="borderAllLow marginsH w3-center">
                              @for (regla of ind.semaforo[semtxt] ?? []; track $index) {
                                <div>{{ regla }}</div>
                              }
                            </th>
                          }
                        }
                        <td class="borderAllLow alinRight">
                          <div [style.border-right]="'5px solid' + ind.colorReal">
                            <span class="w3-elemento-tableIndicador" style="margin-right: 1vh;">{{ind.presupuesto}} %</span>
                          </div> 
                        </td>
                        <td class="borderAllLow alinRight">
                          <div [style.border-right]="'5px solid' + ind.colorPres">
                            <span class="w3-elemento-tableIndicador" style="margin-right: 1vh;">{{ind.real}} %</span>
                          </div> 
                        </td>
                        <td class="borderAllLow marginsH alinRight">{{ind.variacion}} %</td> 
                      </tr>  
                    }
                  }
                </tbody>
              </table>
            }  
          </div>
          
        </div>
        <!-- Grafica indicador seleccionado -->
        <div class="zona2 w3-row">
          <div class="w3-row w3-header-cuadrante">
            <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
              <span class="w3-margin-left-contenido">{{'segPresupuestal.razonesFinancieras.evolucion' | translate}} {{ indSeleccionado?.nombre }}</span>
              <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
              <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
            </div>
            <div class="w3-rest w3-right">
              @if(etiqueta){
                <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" fontSet="material-icons-outlined"
                  (click)="changeLabel = !changeLabel"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
              }
              <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}"  fontSet="material-icons-outlined"
                (click)="etiqueta = !etiqueta" [matTooltip]="etiqueta ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
                {{ etiqueta ? 'label_off' : 'label'}}
              </mat-icon>
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                  (click)="ampliarGraf(0)" matTooltip="{{'tooltips.tooltipIcono2'|translate}}">
                  zoom_out_map
              </mat-icon>
              <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
                  [matMenuTriggerFor]="opcionesGraf" matTooltip="Más opciones">
                  more_vert
              </mat-icon>
              <mat-menu #opcionesGraf="matMenu">
                <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuGraf">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">insert_chart</mat-icon>
                  <span>{{'graf.graficas' | translate}}</span>
                </button> 
                <button class="mat-menu-item" mat-menu-item (click)="exportarGrafica(0)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button> 
              </mat-menu>
              <mat-menu #menuGraf>
                <button class="mat-menu-item" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraf === typeGraph.COMBO}"
                  [disabled]="tipoGraf === typeGraph.COMBO"
                  (click)="cambiarTipoGrafica(typeGraph.COMBO)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.combinada'|translate}}</span>
                </button>
                <button class="mat-menu-item" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraf === typeGraph.BAR}"
                  [disabled]="tipoGraf === typeGraph.BAR"
                  (click)="cambiarTipoGrafica(typeGraph.BAR)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.barras'|translate}}</span>
                </button>
                <button class="mat-menu-item" mat-menu-item 
                    [ngClass]="{'w3-disabled': tipoGraf === typeGraph.LINE}"
                    [disabled]="tipoGraf === typeGraph.LINE"
                    (click)="cambiarTipoGrafica(typeGraph.LINE)">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button class="mat-menu-item" mat-menu-item 
                    [ngClass]="{'w3-disabled': tipoGraf === typeGraph.AREA}"
                    [disabled]="tipoGraf === typeGraph.AREA"
                    (click)="cambiarTipoGrafica(typeGraph.AREA)">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'graf.area'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="w3-row zonaGrafPrin">
            @if(dataGraf.length === 0 ){
              <app-skeleton-grafica/>
            }@else {
              <app-graficador 
                [data]="dataGraf"
                [labels]="etiquetasGraf"
                [type]="tipoGraf"
                [colors]="coloresGrafico"
                [axisY]="['% variación','% valor indicador']"
                [axisX]="'Periodos'"
                [zona]="0"
                [legend]="{enabled: true, position: 'bottom'}"
                [etiquetas]="etiqueta"
                [changeLabel]="changeLabel"
                [animations]="true"
                [setTwoLast]="true"
                [formatEtiquetas]="true"
                [stroke]="true">
              </app-graficador>
            }
          </div>
        </div>     
      </div>         
    }@else {
      <!-- Vista graficas indicadores -->
      <div class="w3-row w3-header-cuadrante w3-white" style="height: 6vh;">
        <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
          <span class="w3-margin-left-contenido">{{'segPresupuestal.razonesFinancieras.grafInd' | translate}} {{ sucursalSeleccionada?.name }}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
        </div>
        <div class="w3-quarter">
          <div class="w3-half">
            <div class="hijoizquierdaTitle">
              <button class="w3-button" [matMenuTriggerFor]="menuPer">
                {{ 'gestion.seguimiento.indicadores.ind' | translate }}
                <mat-icon class="iconoMen">expand_more</mat-icon>
              </button>
              <mat-menu class="w3-medium" #menuPer="matMenu">
                @for(graf of graficasLineales; track graf.id) {                  
                  <button mat-menu-item
                    (click)="$event.stopPropagation(); graf.check = !graf.check">
                    <div class="w3-quince">
                      <input style="cursor: pointer; margin-top: 7px;"
                        [checked]="graf.check" type="checkbox"
                        (click)="$event.stopPropagation();"
                        (change)="graf.check = !graf.check">
                    </div>
                    <div class="w3-rest textoOverFlow">
                      <span style="margin-left: 5px;">{{graf.name}}</span>
                    </div>
                  </button>
                }
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="w3-rest w3-right">
          <button class="mat-menu-item"
              matTooltip="{{ 'segPresupuestal.razonesFinancieras.verTabla' | translate }}"
              mat-menu-item class="w3-caja-menu" (click)="vistaGraf = !vistaGraf">
              <mat-icon [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
          </button>
        </div>
      </div>
      <!-- Zona graficas -->
       <div class="w3-row" style="height: 90%; overflow: scroll; width: 100%;">
        @if(graficasLineales.length > 0){
          @for(graf of graficasLineales; track graf.id; let i = $index){
            @if(graf.labels.length != 0 && graf.check){
              <div [id]="'graf'+i" class="grafLin w3-white">
                <div class="titulo">
                  <div class="w3-noventa2 w3-titulo-contenidomenuSC padreizquierda">
                    <div class="hijoizquierdaTitle">
                      <span class="w3-margin-left-contenido w3-tituloZonas">{{graf.name}}</span>
                    </div>
                  </div>
                  <div class="w3-rest">
                    <div class="w3-right">
                      <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                          (click)="ampliarGraf(i+1, graf)" matTooltip="{{'tooltips.tooltipIcono2'|translate}}">
                          zoom_out_map
                      </mat-icon>
                      <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
                        [ngStyle]="{'color':'gray'}"
                        [matMenuTriggerFor]="menutabla">more_vert</mat-icon>
                      <mat-menu #menutabla="matMenu">
                        <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
                          (click)="graf.check = !graf.check">
                          <mat-icon [ngStyle]="{'color':'gray'}">close</mat-icon>
                          <span>{{ 'gestion.seguimiento.indicadores.option1' | translate }}</span>
                        </button>
                        <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
                          (click)="exportarGrafica(i+1)">
                          <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                          <span>{{ 'gestion.seguimiento.indicadores.option2' | translate }}</span>
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <div class="w3-row contGraf">
                  <app-graficador
                    [colors]="coloresGrafico"
                    [etiquetas]="false"
                    [data]="graf.series"
                    [labels]="graf.labels"
                    [type]="typeGraph.LINE"
                    [axisX]="'Periodos'"
                    [axisY]="['% variación','% valor indicador']"
                    [zona]="i+1"
                    [formatEtiquetas]="false"
                    [setTwoLast]="true"
                    [animations]="false"
                    [legend]="{enabled: true, position: 'bottom'}"
                    [stroke]="true"
                  />
                </div>
              </div>
            }
          }
        }@else{<app-skeleton-grafica/>}
       </div>
    }
  </div>
</app-esqueleto-tableros>

<!--Modal ampliar grafica-->
<app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{titModal}}</span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ subtitModal }}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <!-- Icono de etiquetas para modal -->
          @if(!vistaGraf){
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}"  fontSet="material-icons-outlined"
              (click)="etiqueta = !etiqueta" [matTooltip]="etiqueta ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
              {{ etiqueta ? 'label_off' : 'label'}}
            </mat-icon>
          }          
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(zonaAmp)" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body>
    <!--area grafica-->
    <div style="width: 70vw;" >
      <div class="w3-row contentGraf">
        @if (modalOpen) {   
          @if(!vistaGraf){
            <app-graficador 
                [data]="dataGraf"
                [labels]="etiquetasGraf"
                [type]="tipoGraf"
                [colors]="coloresGrafico"
                [axisY]="['% variación','% valor indicador']"
                [axisX]="'Periodos'"
                [zona]="999"
                [legend]="{enabled: true, position: 'bottom'}"
                [etiquetas]="etiqueta"
                [changeLabel]="changeLabel"
                [animations]="true"
                [setTwoLast]="true"
                [formatEtiquetas]="true"
                [stroke]="true">
              </app-graficador>
          }@else {
            <app-graficador
              [etiquetas]="false"
              [colors]="coloresGrafico"
              [data]="grafAmp.series"
              [labels]="grafAmp.labels"
              [type]="typeGraph.LINE"
              [axisX]="'Periodos'"
              [axisY]="['% variación','% valor indicador']"
              [zona]="1000"
              [formatEtiquetas]="false"
              [setTwoLast]="true"
              [animations]="false"
              [legend]="{enabled: false, position: 'bottom'}"
              [stroke]="true"
            />
          }          
        }
      </div>
    </div>
  </div>
</app-modal>